export const ERRORS = {
  ALTERNATIVE_DATE_IS_NOT_AVAILABLE: 'ALTERNATIVE_DATE_IS_NOT_AVAILABLE',
  CLEAN_ALREADY_EXISTS_ON_CYCLE: 'CLEAN_ALREADY_EXISTS_ON_CYCLE',
  BLOCKED_DATE: 'BLOCKED_DATE',
  DATE_IS_NOT_AVAILABLE: 'DATE_IS_NOT_AVAILABLE',
  OBJECT_NOT_FOUND: 'OBJECT_NOT_FOUND',
  OUT_OF_SERVICE_COVERAGE: 'OUT_OF_SERVICE_COVERAGE'
};

export function checkIfRescheduleError(errorName) {
  return (
    errorName === ERRORS.ALTERNATIVE_DATE_IS_NOT_AVAILABLE ||
    errorName === ERRORS.CLEAN_ALREADY_EXISTS_ON_CYCLE ||
    errorName === ERRORS.BLOCKED_DATE ||
    errorName === ERRORS.DATE_IS_NOT_AVAILABLE
  );
}

export function formatError(error) {
  const { path, message, name, metaInfo } = error || {};
  if (path && Array.isArray(path)) {
    return {
      [path]: message
    };
  }

  return {
    name,
    metaInfo,
    message
  };
}

export function getErrors(err) {
  if (err.response) {
    const { data } = err.response;
    const { error } = data || {};
    const { errors } = error || {};

    if (errors && Array.isArray(errors)) {
      return formatError(errors[0]);
    }

    return formatError(error);
  }

  return formatError(err);
}
